window.Visualizations.Composites.SideBySideSunburst = Object.assign({}, window.Visualizations.Highcharts.Base, {
  setup(opts) {
    const container = document.getElementById(opts.containerID);
    if (!container) return;

    const inputArrows = (arrow) => {
      const input = arrow.parentElement?.querySelector('input');
      if (!input) return;

      let baseVal = parseInt(input.value, 10);

      const hiddenArrowUp = document.querySelector('.child-sunbursts .arrow-up');
      const hiddenArrowDown = document.querySelector('.child-sunbursts .arrow-down');

      if (arrow.className.match(/up/) && baseVal < parseInt(input.getAttribute('max'), 10)) {
        hiddenArrowUp?.click();
        baseVal += 1;
      } else if (arrow.className.match(/down/) && baseVal > parseInt(input.getAttribute('min'), 10)) {
        hiddenArrowDown?.click();
        baseVal -= 1;
      }

      if (baseVal === parseInt(input.value, 10)) return;
      input.value = String(baseVal);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    document.querySelectorAll('.side-by-side-sunburst-input [class^=arrow-]').forEach((arrow) => {
      arrow.addEventListener('click', () => inputArrows(arrow));
    });
  }
});
